module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACiSURBVHgBpU+xDcMgEDSGgtIjZJRsEGWCJAXQOhOYDRxXCGgYIdkko1DSkcOiCJZSRH7p9XB3f6fvuj+LbAHv/ZRzHleSkCCEuH/z/UY8Q6zxfGK+yqK1VjcJxpgDpXSG2wDBEViQUt4KCXEAfkK/y58xdu4557GIq0Fs3AjJGCsHs5hSGpobSjxEU0mp0BW9IHH8ebRz7oFxqa6LUkp3e+oDkto76y9Ot88AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ai-id.png
// module id = +Rja
// module chunks = 46